(() => {
  const root = document.querySelector('.cabane-flat-filters');
  if (!root) return;
  const facets = () => [...root.querySelectorAll('#FacetsWrapperDesktop > details')];
  const close = detail => {
    detail.open = false;
    detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  };
  root.addEventListener('toggle', event => {
    const detail = event.target;
    if (!detail.matches('#FacetsWrapperDesktop > details')) return;
    detail.querySelector('summary')?.setAttribute('aria-expanded', String(detail.open));
    if (detail.open) {
      facets().forEach(other => { if (other !== detail) close(other); });
      const box = detail.getBoundingClientRect();
      const wrapper = detail.parentElement.getBoundingClientRect();
      detail.toggleAttribute('data-align-end', box.left > wrapper.left + wrapper.width / 2 - 4);
    }
  }, true);
  document.addEventListener('click', event => {
    facets().forEach(detail => { if (detail.open && !detail.contains(event.target)) close(detail); });
  });
  root.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const detail = event.target.closest('#FacetsWrapperDesktop > details[open]');
    if (!detail) return;
    event.preventDefault();
    close(detail);
    detail.querySelector('summary')?.focus();
  });
})();
